import { ReactComponent as PlusIcon } from "../../Assets/plus-solid.svg";
import FormLoading from "../../Components/FormLoading/FormLoading";
import { getOperatorInfo } from "../../Components/WidgetHeader/WidgetHeader";
import { useConfigStore } from "../../Stores/Config";
import { Ticket } from "../../Stores/Ticket";
import {
  formatCompactTime,
  getConversationPreview,
} from "./chatbarConversationHelpers";

export default function ChatbarConversationDropdown({
  tickets,
  loading,
  currentShareToken,
  onSelect,
  onNewChat,
  onClose,
}: {
  tickets: Ticket[];
  loading: boolean;
  currentShareToken?: string;
  onSelect: (shareToken: string) => void;
  onNewChat: () => void;
  onClose: () => void;
}) {
  const configStore = useConfigStore();
  const config = configStore.config;

  const newChatLabel = (() => {
    const t = configStore.translateText("newConversation");
    return t === "newConversation" ? "New conversation" : t;
  })();

  return (
    <>
      <div className="chatbar-dropdown-scrim" onClick={onClose} />
      <div className="chatbar-dropdown" role="menu">
        {loading && tickets.length === 0 ? (
          <div className="chatbar-dropdown-loading">
            <FormLoading />
          </div>
        ) : (
          <div className="chatbar-dropdown-list">
            {tickets.map((ticket) => {
              const operatorInfo = getOperatorInfo(configStore, config, ticket);
              const active =
                !!currentShareToken && ticket.shareToken === currentShareToken;
              return (
                <button
                  key={ticket.id ?? ticket.shareToken}
                  className={`chatbar-dropdown-row ${
                    active ? "chatbar-dropdown-row--active" : ""
                  }`}
                  role="menuitem"
                  onClick={() =>
                    ticket.shareToken && onSelect(ticket.shareToken)
                  }
                >
                  <span className="chatbar-dropdown-row-avatar">
                    {operatorInfo?.image}
                  </span>
                  <span className="chatbar-dropdown-row-text">
                    {getConversationPreview(ticket, configStore.translateText)}
                  </span>
                  <span className="chatbar-dropdown-row-time">
                    {formatCompactTime(ticket)}
                  </span>
                </button>
              );
            })}
          </div>
        )}
        <div className="chatbar-dropdown-separator" />
        <button
          className="chatbar-dropdown-new"
          role="menuitem"
          onClick={onNewChat}
        >
          <PlusIcon className="chatbar-dropdown-new-icon" />
          <span>{newChatLabel}</span>
        </button>
      </div>
    </>
  );
}
